import { render } from "./Paintover.vue?vue&type=template&id=16f03b74"
import script from "./Paintover.vue?vue&type=script&lang=ts"
export * from "./Paintover.vue?vue&type=script&lang=ts"

import "./Paintover.vue?vue&type=style&index=0&id=16f03b74&lang=scss"
script.render = render

export default script